export default __webpack_public_path__ + "static/media/Denim.8592f3bc.webp";